function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with getavataaars.com");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "path-1",
  cx: 120,
  cy: 120,
  r: 120
}), React.createElement("path", {
  d: "M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z",
  id: "path-3"
}), React.createElement("path", {
  d: "M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z",
  id: "path-5"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Avataaar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-825.000000, -1100.000000)",
  id: "Avataaar/Circle"
}, React.createElement("g", {
  transform: "translate(825.000000, 1100.000000)"
}, React.createElement("g", {
  id: "Circle",
  strokeWidth: 1,
  fillRule: "evenodd",
  transform: "translate(12.000000, 40.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Circle-Background",
  fill: "#E6E6E6",
  xlinkHref: "#path-1"
}), React.createElement("g", {
  id: "Color/Palette/Blue-01",
  mask: "url(#mask-2)",
  fill: "#65C9FF"
}, React.createElement("rect", {
  id: "\\uD83D\\uDD8DColor",
  x: 0,
  y: 0,
  width: 240,
  height: 240
}))), React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3"
})), React.createElement("g", {
  id: "Mask"
}), React.createElement("g", {
  id: "Avataaar",
  strokeWidth: 1,
  fillRule: "evenodd",
  mask: "url(#mask-4)"
}, React.createElement("g", {
  id: "Body",
  transform: "translate(32.000000, 36.000000)"
}, React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-5"
})), React.createElement("use", {
  fill: "#D0C6AC",
  xlinkHref: "#path-5"
}), React.createElement("g", {
  id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFD-03-Brown",
  mask: "url(#mask-6)",
  fill: "#FFDBB4"
}, React.createElement("g", {
  transform: "translate(-32.000000, 0.000000)",
  id: "Color"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 264,
  height: 244
}))), React.createElement("path", {
  d: "M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z",
  id: "Neck-Shadow",
  fillOpacity: 0.100000001,
  fill: "#000000",
  mask: "url(#mask-6)"
})), React.createElement("g", {
  id: "Clothing/Blazer-+-Sweater",
  transform: "translate(0.000000, 170.000000)"
}, React.createElement("defs", null, React.createElement("path", {
  d: "M105.192402,29.0517235 L104,29.0517235 L104,29.0517235 C64.235498,29.0517235 32,61.2872215 32,101.051724 L32,110 L232,110 L232,101.051724 C232,61.2872215 199.764502,29.0517235 160,29.0517235 L160,29.0517235 L158.807598,29.0517235 C158.934638,30.0353144 159,31.0364513 159,32.0517235 C159,45.8588423 146.911688,57.0517235 132,57.0517235 C117.088312,57.0517235 105,45.8588423 105,32.0517235 C105,31.0364513 105.065362,30.0353144 105.192402,29.0517235 Z",
  id: "react-path-308"
})), React.createElement("mask", {
  id: "react-mask-309",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#react-path-308"
})), React.createElement("use", {
  id: "Clothes",
  fill: "#E6E6E6",
  fillRule: "evenodd",
  xlinkHref: "#react-path-308"
}), React.createElement("g", {
  id: "Color/Palette/Black",
  mask: "url(#react-mask-309)",
  fillRule: "evenodd",
  fill: "#262E33"
}, React.createElement("rect", {
  id: "\\uD83D\\uDD8DColor",
  x: 0,
  y: 0,
  width: 264,
  height: 110
})), React.createElement("g", {
  id: "Blazer",
  strokeWidth: 1,
  fillRule: "evenodd",
  transform: "translate(32.000000, 28.000000)"
}, React.createElement("path", {
  d: "M68.784807,1.12222847 C30.512317,2.80409739 1.24427139e-14,34.3646437 0,73.0517235 L0,82 L69.3616767,82 C65.9607412,69.9199941 64,55.7087296 64,40.5 C64,26.1729736 65.7399891,12.7311115 68.784807,1.12222847 Z M131.638323,82 L200,82 L200,73.0517235 C200,34.7067641 170.024954,3.36285166 132.228719,1.17384225 C135.265163,12.7709464 137,26.1942016 137,40.5 C137,55.7087296 135.039259,69.9199941 131.638323,82 Z",
  id: "Saco",
  fill: "#3A4C5A"
}), React.createElement("path", {
  d: "M149,58 L158.555853,50.83311 L158.555853,50.83311 C159.998897,49.7508275 161.987779,49.7682725 163.411616,50.8757011 L170,56 L149,58 Z",
  id: "Pocket-hanky",
  fill: "#E6E6E6"
}), React.createElement("path", {
  d: "M69,1.13686838e-13 C65,19.3333333 66.6666667,46.6666667 74,82 L58,82 L44,46 L50,37 L44,31 L63,1 C65.027659,0.369238637 67.027659,0.0359053037 69,1.13686838e-13 Z",
  id: "Wing",
  fill: "#2F4351"
}), React.createElement("path", {
  d: "M151,1.13686838e-13 C147,19.3333333 148.666667,46.6666667 156,82 L140,82 L126,46 L132,37 L126,31 L145,1 C147.027659,0.369238637 149.027659,0.0359053037 151,1.13686838e-13 Z",
  id: "Wing",
  fill: "#2F4351",
  transform: "translate(141.000000, 41.000000) scale(-1, 1) translate(-141.000000, -41.000000) "
})), React.createElement("path", {
  d: "M156,21.5390062 C162.772319,26.1359565 167,32.6563196 167,39.8878801 C167,47.2887711 162.572015,53.9447688 155.520105,58.5564942 L149.57933,53.8764929 L145,54.207887 L146,51.0567821 L145.922229,50.995516 C152.022491,47.8530505 156,42.7003578 156,36.8768102 L156,21.5390062 Z M108,21.5390062 C101.227681,26.1359565 97,32.6563196 97,39.8878801 C97,47.2887711 101.427985,53.9447688 108.479895,58.5564942 L114.42067,53.8764929 L119,54.207887 L118,51.0567821 L118.077771,50.995516 C111.977509,47.8530505 108,42.7003578 108,36.8768102 L108,21.5390062 Z",
  id: "Collar",
  fill: "#F2F2F2",
  fillRule: "evenodd"
})), React.createElement("g", {
  id: "Face",
  transform: "translate(76.000000, 82.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Mouth/Smile",
  transform: "translate(2.000000, 52.000000)"
}, React.createElement("defs", null, React.createElement("path", {
  d: "M35.117844,15.1280772 C36.1757121,24.6198025 44.2259873,32 54,32 C63.8042055,32 71.8740075,24.574136 72.8917593,15.0400546 C72.9736685,14.272746 72.1167429,13 71.042767,13 C56.1487536,13 44.7379213,13 37.0868244,13 C36.0066168,13 35.0120058,14.1784435 35.117844,15.1280772 Z",
  id: "react-path-320"
})), React.createElement("mask", {
  id: "react-mask-321",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#react-path-320"
})), React.createElement("use", {
  id: "Mouth",
  fillOpacity: 0.699999988,
  fill: "#000000",
  fillRule: "evenodd",
  xlinkHref: "#react-path-320"
}), React.createElement("rect", {
  id: "Teeth",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  mask: "url(#react-mask-321)",
  x: 39,
  y: 2,
  width: 31,
  height: 16,
  rx: 5
}), React.createElement("g", {
  id: "Tongue",
  strokeWidth: 1,
  fillRule: "evenodd",
  mask: "url(#react-mask-321)",
  fill: "#FF4F6D"
}, React.createElement("g", {
  transform: "translate(38.000000, 24.000000)"
}, React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11
}), React.createElement("circle", {
  cx: 21,
  cy: 11,
  r: 11
})))), React.createElement("g", {
  id: "Nose/Default",
  transform: "translate(28.000000, 40.000000)",
  fillOpacity: 0.16
}, React.createElement("path", {
  d: "M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8",
  id: "Nose"
})), React.createElement("g", {
  id: "Eyes/Default-\\uD83D\\uDE00",
  transform: "translate(0.000000, 8.000000)",
  fillOpacity: 0.599999964
}, React.createElement("circle", {
  id: "Eye",
  cx: 30,
  cy: 22,
  r: 6
}), React.createElement("circle", {
  id: "Eye",
  cx: 82,
  cy: 22,
  r: 6
})), React.createElement("g", {
  id: "Eyebrow/Natural/Raised-Excited-Natural",
  fillOpacity: 0.599999964
}, React.createElement("path", {
  d: "M22.7663531,1.57844898 L23.6772984,1.17582144 C28.9190996,-0.905265751 36.8645466,-0.0328729562 41.7227321,2.29911638 C42.2897848,2.57148957 41.9021563,3.4519421 41.3211012,3.40711006 C26.4021788,2.25602197 16.3582869,11.5525942 12.9460869,17.8470939 C12.8449215,18.0337142 12.5391523,18.05489 12.4635344,17.8808353 C10.156283,12.5620676 16.9134476,3.89614725 22.7663531,1.57844898 Z",
  id: "Eye-Browse-Reddit"
}), React.createElement("path", {
  d: "M80.7663531,1.57844898 L81.6772984,1.17582144 C86.9190996,-0.905265751 94.8645466,-0.0328729562 99.7227321,2.29911638 C100.289785,2.57148957 99.9021563,3.4519421 99.3211012,3.40711006 C84.4021788,2.25602197 74.3582869,11.5525942 70.9460869,17.8470939 C70.8449215,18.0337142 70.5391523,18.05489 70.4635344,17.8808353 C68.156283,12.5620676 74.9134476,3.89614725 80.7663531,1.57844898 Z",
  id: "Eye-Browse-Reddit",
  transform: "translate(85.000000, 9.000000) scale(-1, 1) translate(-85.000000, -9.000000) "
}))), React.createElement("g", {
  id: "Top",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("defs", null, React.createElement("rect", {
  id: "react-path-316",
  x: 0,
  y: 0,
  width: 264,
  height: 280
}), React.createElement("path", {
  d: "M183.679824,38.9488198 C189.086072,33.9985622 190.387393,23.9615454 187.317704,17.4493246 C183.549263,9.45385312 175.901319,8.45217737 168.572342,11.9686703 C161.664469,15.2835661 155.515175,16.3878671 147.950196,14.7817319 C140.691624,13.2406923 133.805566,10.5226172 126.303388,10.0762471 C113.978028,9.34292483 102.003367,13.914565 93.6031232,23.1292512 C92.0003538,24.8871655 90.7089493,26.8971594 89.4882796,28.9343872 C88.5115454,30.5644351 87.4105298,32.3133822 86.9950459,34.1921885 C86.7973853,35.0855929 87.165272,37.2898774 86.7203704,38.0218712 C86.2391099,38.8123183 84.4244668,39.5373375 83.6510124,40.1238625 C82.0842713,41.3125222 80.7267597,42.6539573 79.4713836,44.1710842 C76.8052796,47.3926541 75.3376994,50.7577001 74.1034777,54.7428152 C70.0005333,67.9877849 69.6528094,83.7412616 74.9569218,96.7467724 C75.6639385,98.4811062 77.8550622,102.098564 79.1431613,98.3847912 C79.3976741,97.6508047 78.8086588,95.1907873 78.8099809,94.4501584 C78.8146084,91.7300906 80.3160587,73.7213568 86.857084,63.6330196 C88.9862338,60.3491948 98.8298903,48.0522456 100.840541,47.9536058 C101.9058,49.6464245 112.720532,60.4624529 140.783385,59.1948919 C153.445253,58.6229725 163.18265,52.9341181 165.520833,50.4680909 C166.549375,56.0008881 178.51323,64.2839965 180.33625,67.6921976 C185.602529,77.5376948 186.770677,97.9957204 188.780988,97.9573368 C190.791299,97.9189532 192.234429,92.7197798 192.647929,91.7270713 C195.719601,84.351669 196.242509,75.0948338 195.914948,67.1684434 C195.487565,56.9663626 191.276535,45.9419513 183.679824,38.9488198 Z",
  id: "react-path-315"
}), React.createElement("filter", {
  x: "-0.8%",
  y: "-2.0%",
  width: "101.5%",
  height: "108.0%",
  filterUnits: "objectBoundingBox",
  id: "react-filter-312"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
  type: "matrix",
  in: "shadowOffsetOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), React.createElement("mask", {
  id: "react-mask-314",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#react-path-316"
})), React.createElement("g", {
  id: "Mask"
}), React.createElement("g", {
  id: "Top/Short-Hair/Short-Waved",
  mask: "url(#react-mask-314)"
}, React.createElement("g", {
  transform: "translate(-1.000000, 0.000000)"
}, React.createElement("g", {
  id: "Facial-Hair/Beard-Magestic",
  transform: "translate(49.000000, 72.000000)"
}, React.createElement("defs", null, React.createElement("path", {
  d: "M65.1802189,77.7372986 C67.3631845,76.1045334 80.4065113,75.4786511 82.757829,74.0894494 C83.4916461,73.6553857 84.0610723,73.215719 84.4997781,72.7800074 C84.938814,73.215719 85.5085703,73.6553857 86.2423874,74.0894494 C88.593375,75.4786511 101.636702,76.1045334 103.819667,77.7372986 C106.030032,79.3908276 107.643571,83.1846831 107.466966,86.15095 C107.255041,89.7101408 103.361486,98.2028927 93.6723269,99.1811016 C91.5576925,96.8281927 88.2368647,95.3104528 84.4997781,95.3104528 C80.7633517,95.3104528 77.4421938,96.8281927 75.3275594,99.1811016 C65.6387308,98.2028927 61.7451757,89.7101408 61.5332501,86.15095 C61.3566455,83.1846831 62.9701849,79.3908276 65.1802189,77.7372986 M103.141638,94.9063813 C103.142958,94.9057221 103.144609,94.905063 103.145929,94.9047334 C103.144278,94.905063 103.142958,94.9057221 103.141638,94.9063813 M65.8453747,94.9014375 C65.8493359,94.9030855 65.8565982,94.9057221 65.8618798,94.9076997 C65.8565982,94.9057221 65.8509864,94.9034151 65.8453747,94.9014375 M144.86259,55.9853335 C144.47439,50.0303878 143.277769,44.1519058 142.233986,38.2862777 C141.952739,36.7072349 140.423706,26 139.734783,26 C139.502391,35.1094058 138.701893,44.0803858 137.669664,53.1393651 C137.361018,55.8475668 137.037848,58.5564277 136.825262,61.2741874 C136.653609,63.4695546 136.959614,66.1220564 136.427819,68.2455739 C135.749129,70.9524573 132.348087,73.4783984 129.702978,74.410795 C123.102915,76.7373371 117.597802,67.1077689 111.960977,64.2911336 C104.643272,60.6347152 92.0637391,59.7639895 84.5816434,64.5297918 C76.9361472,59.7639895 64.356614,60.6347152 57.0389092,64.2911336 C51.4024147,67.1077689 45.8969708,76.7373371 39.2972383,74.410795 C36.6521296,73.4783984 33.2504268,70.9524573 32.572397,68.2455739 C32.0402723,66.1220564 32.346277,63.4695546 32.174954,61.2741874 C31.9623682,58.5564277 31.6388681,55.8475668 31.3302226,53.1393651 C30.2983232,44.0803858 29.4974953,35.1094058 29.2654335,26 C28.5761802,26 27.0468169,36.7072349 26.7658999,38.2862777 C25.7221169,44.1519058 24.5258266,50.0303878 24.1376265,55.9853335 C23.738533,62.1047422 24.2148704,68.1674622 25.4695887,74.1632765 C26.0687242,77.0277016 26.7685407,79.8756475 27.518863,82.7041478 C28.352701,85.8467429 27.198994,91.9661516 27.5723395,95.1921317 C28.2787581,101.29572 31.1542781,113.199679 34.3833375,118.45096 C35.9440605,120.989096 37.7734867,122.573742 39.816489,124.619148 C41.7825775,126.58809 42.6038717,129.640049 44.7260985,131.73687 C48.6820428,135.645092 54.4456266,137.971304 60.3656788,138.543134 C65.6773527,143.050212 74.505605,146 84.4997781,146 C94.4946114,146 103.322534,143.050212 108.634538,138.543134 C114.55393,137.971304 120.317843,135.645092 124.274118,131.73687 C126.396015,129.640049 127.217309,126.58809 129.183727,124.619148 C131.2264,122.573742 133.055826,120.989096 134.616879,118.45096 C137.845608,113.199679 140.721458,101.29572 141.427547,95.1921317 C141.800892,91.9661516 140.647185,85.8467429 141.481353,82.7041478 C142.231676,79.8756475 142.931162,77.0277016 143.530628,74.1632765 C144.784686,68.1674622 145.261353,62.1047422 144.86259,55.9853335 Z",
  id: "react-path-318"
})), React.createElement("mask", {
  id: "react-mask-317",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#react-path-318"
})), React.createElement("use", {
  id: "Glorious-Beard",
  fill: "#5E7AA9",
  fillRule: "evenodd",
  xlinkHref: "#react-path-318"
}), React.createElement("g", {
  id: "Color/Hair/Brown",
  mask: "url(#react-mask-317)",
  fill: "#B58143"
}, React.createElement("g", {
  transform: "translate(-32.000000, 0.000000)",
  id: "Color"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 264,
  height: 244
})))), React.createElement("mask", {
  id: "react-mask-313",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#react-path-315"
})), React.createElement("use", {
  id: "Short-Hair",
  stroke: "none",
  fill: "#28354B",
  fillRule: "evenodd",
  xlinkHref: "#react-path-315"
}), React.createElement("g", {
  id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFD-03-Brown",
  mask: "url(#react-mask-313)",
  fill: "#D6B370"
}, React.createElement("g", {
  transform: "translate(0.000000, 0.000000) ",
  id: "Color"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 264,
  height: 280
}))), React.createElement("g", {
  id: "Top/_Resources/Prescription-02",
  fill: "none",
  transform: "translate(62.000000, 85.000000)",
  strokeWidth: 1
}, React.createElement("defs", null, React.createElement("filter", {
  x: "-0.8%",
  y: "-2.4%",
  width: "101.5%",
  height: "109.8%",
  filterUnits: "objectBoundingBox",
  id: "react-filter-319"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
  type: "matrix",
  in: "shadowOffsetOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), React.createElement("g", {
  id: "Wayfarers",
  filter: "url(#react-filter-319)",
  transform: "translate(6.000000, 7.000000)",
  fill: "#252C2F"
}, React.createElement("path", {
  d: "M34,41 L31.2421498,41 C17.3147125,41 9,33.3359286 9,20.5 C9,10.127 10.8170058,0 32.5299306,0 L35.4700694,0 C57.1829942,0 59,10.127 59,20.5 C59,32.5686429 48.7212748,41 34,41 Z M32.3853606,6 C13,6 13,12.8410159 13,21.5015498 C13,28.5719428 16.116254,37 30.9709365,37 L34,37 C46.3649085,37 55,30.6270373 55,21.5015498 C55,12.8410159 55,6 35.6146394,6 L32.3853606,6 Z",
  id: "Left",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M96,41 L93.2421498,41 C79.3147125,41 71,33.3359286 71,20.5 C71,10.127 72.8170058,0 94.5299306,0 L97.4700694,0 C119.182994,0 121,10.127 121,20.5 C121,32.5686429 110.721275,41 96,41 Z M94.3853606,6 C75,6 75,12.8410159 75,21.5015498 C75,28.5719428 78.1194833,37 92.9709365,37 L96,37 C108.364909,37 117,30.6270373 117,21.5015498 C117,12.8410159 117,6 97.6146394,6 L94.3853606,6 Z",
  id: "Right",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M2.95454545,5.77156439 C3.64590909,5.09629136 11.2095455,0 32.5,0 C50.3513636,0 54.1302273,1.85267217 59.8502273,4.6518809 L60.2689233,4.85850899 C60.6666014,4.99901896 62.7002447,5.68982981 65.0790606,5.76579519 C67.2462948,5.67278567 69.1000195,5.08540191 69.641698,4.89719767 C76.1703915,1.7220864 82.5610971,0 97.5,0 C118.790455,0 126.354091,5.09629136 127.045455,5.77156439 C128.679318,5.77156439 130,7.06150904 130,8.65734659 L130,11.5431288 C130,13.1389663 128.679318,14.428911 127.045455,14.428911 C127.045455,14.428911 120.143997,14.428911 120.143997,17.3146932 C120.143997,20.2004754 118.181818,13.1389663 118.181818,11.5431288 L118.181818,8.73240251 C114.578575,7.35340151 108.128411,4.78617535 97.5,4.78617535 C85.6584651,4.78617535 79.7610984,6.88602813 74.7022935,8.97112368 L74.7588636,9.10752861 L74.7563667,11.0937608 L72.5391666,16.4436339 L69.8004908,15.3608351 C69.5558969,15.2641292 69.0281396,15.090392 68.2963505,14.9099044 C66.256272,14.4067419 64.1589087,14.253569 62.3040836,14.6343084 C61.6235903,14.7739931 60.9922286,14.9836085 60.4128127,15.266732 L57.7704824,16.5578701 L55.1266751,11.3962031 L55.2440909,9.10175705 L55.3248203,8.90683855 C50.9620526,6.87386374 46.9392639,4.78617535 32.5,4.78617535 C21.8721459,4.78617535 15.422131,7.3524397 11.8181818,8.7314671 L11.8181818,11.5431288 C11.8181818,13.1389663 8.86363636,20.2004754 8.86363636,17.3146932 C8.86363636,14.428911 2.95454545,14.428911 2.95454545,14.428911 C1.32363636,14.428911 0,13.1389663 0,11.5431288 L0,8.65734659 C0,7.06150904 1.32363636,5.77156439 2.95454545,5.77156439 Z",
  id: "Stuff",
  fillRule: "nonzero"
}))))))))));

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "264px",
    height: "280px",
    viewBox: "0 0 264 280",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.c92320bd.svg";
export { ForwardRef as ReactComponent };